module.exports = __webpack_public_path__ + "static/media/toolbar-zoom-in.3280d792.svg";